import { render, staticRenderFns } from "./OrderDetailsRead.vue?vue&type=template&id=261d18ae"
import script from "./OrderDetailsRead.vue?vue&type=script&lang=js"
export * from "./OrderDetailsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports